import React from "react";
import Box from "@mui/material/Box";

interface ItemProps {
  label: string;
  value: string;
  column?: boolean;
  hasAmount?: boolean;
  fontSize?: number;
  labelSX?: any;
  children?: any;
}

export const Item:React.FunctionComponent<ItemProps> = ({
  label,
  value ,
  column= false,
  hasAmount = false,
  fontSize = 14,
  labelSX = {},
  children,
}) => {
  if (column) {
    return (
      <Box sx={{display: 'flex', flexDirection: 'column' }}>
        <Box sx={{opacity: 0.5, mb: 1, fontSize: fontSize, ...labelSX}}>{label}</Box>
        {children ? children : (
          <Box sx={{fontSize: fontSize}}>{hasAmount ? `$${Number(value).toFixed(2)}` : value}</Box>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2 }}>
      <Box sx={{opacity: 0.5, mr: 3, fontSize: fontSize}}>{label}</Box>
      <Box sx={{fontSize: fontSize}}>{hasAmount ? `$${Number(value).toFixed(2)}` : value}</Box>
    </Box>
  );
}